import { AssignmentPriority } from "@/api";

export interface AssignmentFormValues {
  dueDate: Date;
  description: string;
  priority: AssignmentPriority;
  assignedCounselorId: string | null;
  assignedClientId: string | null;
}

export interface AssignmentPriorityOption {
  id: AssignmentPriority;
  label: string;
}

export const AssignmentMaxLength = {
  description: 250,
};
